export enum SnackbarType {
    SUCCESS = "success",
    WARNING = "warning",
    FAILED = "failed",
    PENDING = "pending" 
}